import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import TariffLine from '~/src/components/TariffLine';

import { PriceSection } from '~/src/components/TariffCard/styled';

export const Tariffs = styled(TariffLine)`
    ${PriceSection} {
        background-color: ${COLORS.BgMain};
    }
`;
